import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { AdviserPortalRootState, AdviserPortalDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AdviserPortalDispatch>();
export const useAppSelector: TypedUseSelectorHook<AdviserPortalRootState> = useSelector;